import { useState } from 'react';

import { Button, Form } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { SignInData } from 'domain/entities/AuthEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { setUser } from 'presentation/redux/features/authen/authenSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { PasswordFormItem } from './components/Password';
import { UsernameFormItem } from './components/Username';

interface props {
    authUseCase: AuthUseCaseInterface;
    userStorage: UserStorageUseCaseInterface;
}

const CU00104Page = ({ authUseCase, userStorage }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [errMessage, setErrMessage] = useState<string>('');
    const [form] = Form.useForm();

    const submit = async (value: any) => {
        try {
            const payload: SignInData = {
                email: value.username,
                password: value.password,
            };
            dispatch(startFetching());
            const response = await authUseCase.signin(payload);
            if (response) {
                if (response.code == 200) {
                    userStorage.setUserInfo(response.data);
                    dispatch(setUser(response.data));
                    navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.DASHBOARD);
                } else {
                    navigate(
                        AUTH_ROUTES.PATH +
                            '/' +
                            AUTH_ROUTES.SUB.CU_001_05 +
                            '?email=' +
                            value.username,
                    );
                }
            }
        } catch (error: any) {
            if (error.code == 400) {
                setErrMessage(error.message);
            } else {
                openErrorNoti();
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const forgotPassword = () => {
        navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_026_01);
    };
    const onChangePassWord = () => {
        setErrMessage('');
    };
    return (
        <Form
            className="width-full-screen center-inside CU-001-04-container"
            style={{
                height: '100vh',
            }}
            form={form}
            onFinish={submit}
            onValuesChange={() => {
                form.validateFields({ validateOnly: true })
                    .then(() => {
                        setIsDisabled(false);
                    })
                    .catch((err) => {
                        setIsDisabled(err.errorFields.length > 0);
                    });
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                    style={{ borderRadius: 100, backgroundColor: '#fff', width: 160, height: 160 }}
                >
                    <img alt="logo" src={Logo} className='logo'/>
                </div>
                <div
                    className="title"
                    style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
                >
                    ログイン
                </div>
                <UsernameFormItem />
                <PasswordFormItem onChange={onChangePassWord} />
                {errMessage && (
                    <div className="flex relative top-[-20px] h-[5px]">
                        <div
                            id="otp_help"
                            className="ant-form-item-explain ant-form-item-explain-connected"
                            role="alert"
                        >
                            <div className="ant-form-item-explain-error">{errMessage}</div>
                        </div>
                    </div>
                )}
                <p style={{ margin: 0 }} className="button-style link" onClick={forgotPassword}>
                    パスワードを忘れた方はこちら
                </p>
                <Button
                    className="button-login-text"
                    type="primary"
                    style={{ width: '100%', height: 56, marginTop: 16 }}
                    disabled={isDisabled}
                    htmlType="submit"
                >
                    ログイン
                </Button>
            </div>
        </Form>
    );
};
export default CU00104Page;
